import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addStockUpdateIntervalsApi, deleteStockUpdateIntervalsApi, getStockUpdateIntervalsApi, updateStockUpdateIntervalsApi } from "../../../services/partners/settings/stockUpdateIntervalService";


export const getAllPartnerStockUpdateIntervals = createAsyncThunk("partner/getAllPartnerStockUpdateIntervals", async (filters, { dispatch }) => {
  const response = await getStockUpdateIntervalsApi(filters);
  return response.response;
});

export const addPartnerStockUpdateIntervals = createAsyncThunk("partner/addPartnerStockUpdateIntervals", async (duration, { dispatch, getState }) => {
  try {
    const response = await addStockUpdateIntervalsApi(duration);
    const data = await response.response;
    toast.success("Add Stock Update Intervals successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updatePartnerStockUpdateIntervals = createAsyncThunk("partner/updatePartnerStockUpdateIntervals", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateStockUpdateIntervalsApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Stock Update Intervals successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deletePartnerStockUpdateIntervals = createAsyncThunk("partner/deletePartnerStockUpdateIntervals", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteStockUpdateIntervalsApi(id);
    const data = await response.response;
    toast.success("Deleted Stock Update Intervals successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnerStockUpdateIntervalsAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerStockUpdateIntervals, selectById: selectPartnerStockUpdateIntervalsId } = partnerStockUpdateIntervalsAdapter.getSelectors(
  (state) => state.partner.partnerStockUpdateIntervals
);

const partnerStockUpdateIntervalsSlice = createSlice({
  name: "partnerStockUpdateIntervals",
  initialState: partnerStockUpdateIntervalsAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerStockUpdateIntervals",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerStockUpdateIntervalsSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerStockUpdateIntervals",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllPartnerStockUpdateIntervals.fulfilled]: partnerStockUpdateIntervalsAdapter.setAll,
  },
});

export const { setPartnerStockUpdateIntervalsSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = partnerStockUpdateIntervalsSlice.actions;

export default partnerStockUpdateIntervalsSlice.reducer;
